import Pages from '../config/Pages';
import BasePageConfig from '../core/page/BasePageConfig';
import Mapper from '../core/service/Mapper';
import { exportar } from '../core/utils/Exporter';
import { printToast } from '../core/utils/Global';
import { inputsHistoricoVersoes } from '../pages/sei/historicoIndicador/PageInputs';

const url = 'historicos-versoes-indicadores';

class HistoricoVersoesIndicadorService {
    constructor() {
        this.config = new BasePageConfig(
            { pageName: Pages.sei.historicoIndicador.tabs.historicoVersoes },
            inputsHistoricoVersoes
        );
    }
    async pesquisar(pagination) {
        const { params } = pagination.getParams();
        const { indicador, ...rest } = params;
        const res = await window.$http.get(url, {
            ...pagination.getParams(),
            params: {
                ...rest,
                sort: 'dataCadastro,desc',
                search: `indicador.id==${indicador?.id}`,
            },
        });
        const mapper = new Mapper();
        const content = await mapper.formatToView(res?.data?.content, this.config);
        return { ...res?.data, content } ?? [];
    }

    async exportaDataToFile(type, filter) {
        const { configExportar } = this.config.getConfigs();
        const exportConfig = this.getExportConfig(type, configExportar.config);
        const typeRoute = type === 'print' ? 'pdf' : type;

        const res = await window.$http.post(
            `${url}/export/${typeRoute}`,
            {
                title: configExportar.title,
                ...exportConfig,
                ...filter,
            },
            {
                responseType: 'blob',
            }
        );
        exportar(res.data, 'pdf', configExportar.title);
        printToast({
            severity: 'success',
            summary: Pages.sei.historicoIndicador.tabs.historicoSituacoes,
            detail: configExportar.messages.success,
        });
    }
    getExportConfig(type, configuracao) {
        if (configuracao[type]) {
            return {
                columns: configuracao[type].columns,
                properties: configuracao[type]['properties'],
            };
        }
        return {
            columns: configuracao.columns,
            properties: configuracao.properties,
        };
    }
}

export default new HistoricoVersoesIndicadorService();
